<script setup lang="ts">
import { useGetMediaUrl } from '~/composables/useGetMediaUrl'

import { countriesArray } from '~/utils/Countries'

import type { Country } from '~/types/Country'

type Props = {
  country: string
  refKey?: keyof Country
  flagKey?: Extract<keyof Country, 'flag_32' | 'flag_128'>
  nameKey?: Extract<
    keyof Country,
    'id' | 'code3l' | 'code2l' | 'name' | 'name_official'
  >
}

const props = withDefaults(defineProps<Props>(), {
  refKey: 'name',
  flagKey: 'flag_128',
  nameKey: 'name',
})

const { getMediaUrl } = useGetMediaUrl()

const countries = ref(countriesArray)
const flagImage = computed(() => {
  for (let i = countries.value.length - 1; i >= 0; i--) {
    if (countries.value[i][props.refKey] === props.country)
      return getMediaUrl('/flags/' + countries.value[i][props.flagKey])
  }

  return ''
})

const flagName = computed(() => {
  for (let i = countries.value.length - 1; i >= 0; i--) {
    if (countries.value[i][props.refKey] === props.country)
      return countries.value[i][props.nameKey]
  }

  return ''
})
</script>

<template>
  <div class="sharedCountryDisplayWrapper">
    <div v-if="flagImage" class="flagHolder">
      <img :src="flagImage" :alt="flagName" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.sharedCountryDisplayWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.flagHolder {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex-inline;
  justify-content: flex-start;
  align-items: flex-start;
}

.flagHolder > img {
  width: 100%;
  height: 100%;
  position: relative;
  object-position: top;
  object-fit: contain;
}

.ttContainer {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 80%;
  height: 100%;
  z-index: 1;
}
</style>
